import React from 'react';

import { Skeleton } from 'components';
import { TableRow } from 'components/Tables';
import { TABLE_HEADINGS } from './stubs';

export default function Loader({ isLoading = false, children = null }) {
  if (!isLoading) return children;

  return Array(2)
    .fill(null)
    .map((_, index) => (
      <TableRow
        key={index}
        values={[
          {
            lg: TABLE_HEADINGS[0].lg,
            CustomComponent: (
              <Skeleton width="50%" height="13px" className="m-0" />
            )
          },
          {
            lg: TABLE_HEADINGS[1].lg,
            CustomComponent: (
              <Skeleton width="30%" height="13px" className="m-0" />
            )
          },
          {
            lg: TABLE_HEADINGS[2].lg,
            CustomComponent: (
              <Skeleton width="80%" height="13px" className="m-0" />
            )
          },
          {
            lg: TABLE_HEADINGS[3].lg,
            CustomComponent: (
              <Skeleton width="32px" height="32px" className="m-0 ml-auto" />
            )
          }
        ]}
      />
    ));
}
